import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/motion";
import { EmptyState } from "@/components/EmptyState";
import { BLOGS } from "@/data/content";

export default function Blogs() {
  const navigate = useNavigate();
  return (
    <main className="bg-[#FDFBF7] min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-16 max-w-[1400px] mx-auto px-6 md:px-10" data-testid="blogs-page">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">— The Journal</p>
        <h1 className="font-serif font-light text-5xl md:text-8xl tracking-tight leading-[0.92] max-w-[16ch]">
          Notes on building brands worth believing.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32 grid md:grid-cols-3 gap-10">
        {BLOGS.length === 0 && <EmptyState label="Journal — coming soon" note="Our insights on brand strategy will be published here soon." />}
        {BLOGS.map((b, i) => (
          <Reveal key={b.slug} i={i}>
            <button
              onClick={() => navigate(`/blogs/${b.slug}`)}
              data-testid={`blog-item-${b.slug}`}
              className="group text-left w-full"
            >
              <div className="relative overflow-hidden h-[260px] mb-5">
                <img src={b.img} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-[#78716C]">
                <span className="text-[#C5A059]">{b.tag}</span> · {b.date} · {b.read}
              </div>
              <h2 className="font-serif text-2xl md:text-3xl mt-3 leading-tight group-hover:text-[#8a6d2f] transition-colors">
                {b.title}
              </h2>
              <p className="text-sm text-[#78716C] mt-3 leading-relaxed">{b.excerpt}</p>
            </button>
          </Reveal>
        ))}
      </section>
      <Footer />
    </main>
  );
}
